"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m12 7.658-.353 1.449h.706zm1.794 1.449-.628-2.578c-.298-1.222-2.034-1.222-2.332 0l-.628 2.578H6.372l-.738-2.619a.7.7 0 1 0-1.348.38l.632 2.239H3.2a.7.7 0 1 0 0 1.4h2.113l.494 1.75H3.2a.7.7 0 1 0 0 1.4h3.002l1.088 3.856c.335 1.188 2.028 1.157 2.32-.042l.93-3.814h2.92l.93 3.814c.292 1.2 1.985 1.23 2.32.042l1.088-3.856H20.8a.7.7 0 1 0 0-1.4h-2.607l.494-1.75H20.8a.7.7 0 0 0 0-1.4h-1.718l.632-2.239a.7.7 0 0 0-1.348-.38l-.738 2.619zm-1.1 1.4h-1.388l-.426 1.75h2.24zm1.867 1.75-.426-1.75h3.098l-.494 1.75zm.34 1.4.669 2.743.774-2.743zm-5.462-1.4.426-1.75H6.767l.494 1.75zm-1.783 1.4L8.43 16.4l.668-2.743z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=CurrencySouthKoreanWonIcon24.js.map